import { withFormsy } from "formsy-react";
import React from "react";
import Moment from "moment";
import Datepicker from "react-datepicker";
import ErrorLabel from "../../../common/errorLabel";
import Tooltip from "../../../common/tooltip";

class DatePickerWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      date: props.getValue() ? Moment(props.getValue()) : null
    };
    this.changeValue = this.changeValue.bind(this);
  }

  changeValue(date) {
    this.props.setValue(date && date.format(this.props.dateFormat));
    this.setState({ date });
  }

  render() {
    const errorMessage = this.props.getErrorMessage();
    const {
      onChange,
      showRequired,
      showError,
      name,
      description,
      label,
      isPristine,
      isRequired,
      className,
      disabledKeyboardNavigation,
      peekNextMonth,
      showMonthDropdown,
      showYearDropdown,
      readOnly,
      dateFormat,
      disableFields,
      maxDate,
      minDate,
      selected,
      dropdownMode
    } = this.props;
    const hasError = !isPristine() && showError();
    const requiredError = showRequired() && !isPristine();

    return (
      <div className="form-group">
        <label
          className={`input-control-label ${isRequired() ? "required" : ""}`}
          htmlFor={name}
        >
          {label} {" "}
          {description && (
            <Tooltip message={description} position={"bottom"}>
              (?)
            </Tooltip>
          )}
        </label>
        <Datepicker
          onChange={onChange || this.changeValue}
          allowSameDay={true}
          maxDate={
            typeof maxDate === "number"
              ? Moment().add(maxDate, "days")
              : maxDate
          }
          minDate={minDate}
          className={`form-control ${
            hasError || requiredError ? "error" : ""
          } ${className}`}
          id={name}
          placeHolderText={label}
          disabledKeyboardNavigation={disabledKeyboardNavigation}
          peekNextMonth={peekNextMonth}
          showMonthDropdown={showMonthDropdown}
          showYearDropdown={showYearDropdown}
          dropdownMode={dropdownMode}
          readOnly={readOnly}
          isClearable={disableFields ? false : true}
          dateFormat={dateFormat}
          disabled={disableFields}
          selected={selected || this.state.date}
        />
        <ErrorLabel message={hasError ? errorMessage : ""} />
        <ErrorLabel message={requiredError ? "Required" : ""} />
      </div>
    );
  }
}

export default withFormsy(DatePickerWrapper);



// WEBPACK FOOTER //
// ./src/components/discover/common/controls/DatePicker.js